module.exports = __webpack_public_path__ + "static/media/happytime.d351d4b8.jpg";